export default "__VITE_ASSET__0b844c4e__"